import { useEffect } from 'react'
import axios, { AxiosResponse } from 'axios'

import { State, useFetchState } from './useFetchState'

export interface ReturnType<T> {
  state: State<T>
  callApi: (apiCall: Promise<AxiosResponse<any>>) => Promise<any>
  setIdle: () => void
}

export function useApi<T>(): ReturnType<T> {
  const { state, setLoading, setSuccess, setError, setIdle } = useFetchState()

  useEffect(() => {
    const source = axios.CancelToken.source()

    const interceptorNumber = axios.interceptors.request.use((config) => {
      config.cancelToken = source.token
      return config
    })

    return () => {
      source.cancel('Llamada cancelada.')
      axios.interceptors.request.eject(interceptorNumber)
    }
  }, [])

  const callApi = (apiCall: Promise<AxiosResponse<any>>) => {
    setLoading()
    return new Promise((resolve, reject) => {
      apiCall
        .then(({ data }) => {
          setSuccess(data)
          resolve(data)
        })
        .catch((error) => {
          let errorMessage = 'Error desconocido'

          // Verifica si el error proviene del backend y extrae el mensaje
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message
          } else if (error.data?.message) {
            errorMessage = error.data.message
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const serverErrors: { Name?: string[] } = error.response.data.errors
            if (
              serverErrors &&
              serverErrors.Name &&
              Array.isArray(serverErrors.Name) &&
              serverErrors.Name.length > 0
            ) {
              errorMessage = serverErrors.Name[0]
            }
          } else if (error.message) {
            // Error de Axios o del navegador
            errorMessage = error.message
          }
          setError(errorMessage)
          reject(errorMessage)
        })
    })
  }

  return {
    state,
    callApi,
    setIdle
  }
}
